import {useCallback} from "react";
import Projects from "../components/Projects/Projects";
import {useNavigate} from "react-router-dom";
import {useInternetSpeedMeasurer} from "../hooks/useInternetSpeedMeasurer";


const HomePage = () => {
    useInternetSpeedMeasurer();
    const navigate = useNavigate();

    const projectClickHandler = useCallback((projectId: string) => {
        navigate(`./${projectId}`);
    }, [])

    const onProjectCreation = useCallback((projectId: string) => {
        navigate(`/${projectId}`);
    }, [])

    return (
        <Projects
            projectClickHandler={projectClickHandler}
            onProjectCreation={onProjectCreation}
        />
    )
}

export default HomePage;